export default async function (this: any, action: any) {
    !this.$state.view.isStepsListLocked && (await action())
}
